import { useEffect } from 'react'
import { useRouterState } from '@tanstack/react-router'

const BRAND = 'Platform'

export function useDocumentTitle(override?: string): void {
  const routeTitle = useRouterState({ select: (s) => s.matches.at(-1)?.staticData.title })
  const page = override ?? routeTitle

  useEffect(() => {
    document.title = page ? `${page} · ${BRAND}` : BRAND
  }, [page])
}
